import { API } from "@/lib/api";
import {
  ProjectLimitSummary,
  ProjectLimitSummaryStoreHours,
  ReadProjectLimitWithDepartment,
  WriteProjectLimit,
} from "@/types/projectLimit";
import { APIService, SuccessFetchListResponse } from "../../../services/api";

class ProjectLimitSummaryAPIService extends APIService<
  ReadProjectLimitWithDepartment,
  WriteProjectLimit
> {
  constructor() {
    super(API.Projects);
  }

  getPeriodsSummary = async (
    projectId: string,
    start: string,
    end: string,
  ): Promise<SuccessFetchListResponse<ProjectLimitSummary>> => {
    return this.getStaticList<SuccessFetchListResponse<ProjectLimitSummary>>(
      `/${projectId}/limits/periods-summary?start=${start}&end=${end}`,
    );
  };

  getStoreHours = async (
    projectId: string,
    start: string,
    end: string,
    params: { lastItem?: string; limit?: number } = {},
  ): Promise<SuccessFetchListResponse<ProjectLimitSummaryStoreHours>> => {
    return this.getList<
      SuccessFetchListResponse<ProjectLimitSummaryStoreHours>
    >(
      {
        lastItem: params.lastItem,
        limit: params.limit,
        queryParams: { start, end },
      },
      `/${projectId}/limits/hours-per-stores`,
    );
  };
}

export const ProjectLimitSummaryService = new ProjectLimitSummaryAPIService();
